<template>
    <div @click.prevent.stop="openReport" title="Print Report" v-bind="$attrs"><reports-icon class="h-6" /></div>
    <teleport to="body">
        <transition name="fade" v-if="preparingReport">
            <old-report-frame v-if="showReport" :report-url="reportUrl" @cancel="closeReport" />
        </transition>
    </teleport>
</template>

<script>
import OldReportFrame from "./OldReportFrame.vue";
import ReportsIcon from "@/components/icons/ReportsIcon";

export default {
    name: "ScoReport",
    components: { OldReportFrame, ReportsIcon },
    props: {
        sco: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            preparingReport: false,
            showReport: false
        };
    },
    computed: {
        hasCareOf() {
            return this.sco.group_id || this.sco.subgroup_id || this.sco.virtual_group_id;
        },
        careOf() {
            if (this.sco.virtual_group_id) {
                let virtualGroup = this.$store.getters.getVirtualGroupById(this.sco.virtual_group_id);
                if (virtualGroup) {
                    return virtualGroup.title;
                }
            }

            if (this.sco.subgroup_id) {
                let subgroup = this.$store.getters.getSubgroupById(this.sco.subgroup_id);
                if (subgroup) {
                    return subgroup.title;
                }
            }

            if (this.sco.group_id) {
                let group = this.$store.getters.getGroupById(this.sco.group_id);
                if (group) {
                    return group.title;
                }
            }

            return "";
        },
        reportUrl() {
            //e.g. https://lms.opuspharmserve.com/LMS/LMS/OPUS_CA(A)_v4_1c/View_Results.html?StudentName=
            //Test Creek&Date=22/03/2021 14:16:23&Group= &Suspend_data=
            //CH,2,9,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,0,0,2,2,0,0,0,0,0,0,0,0,0,
            //Further Training Required,19/02/2021,Consult your line manager,1,true&rwndrnd=0.5543859460989127

            let url = `/storage/content/${this.sco.abstract_course_id}/${this.sco.course_id}/${this.sco.sco_id}`;
            url += `/View_Results.html?`;
            url += `StudentName=${this.studentName}&`;
            url += `Date=${this.reportDate}&`;
            url += `Group=${this.group}&`;
            url += `Suspend_data=${this.lessonLocation}&`;
            url += `rwndrnd=${this.cacheBuster}`;

            return url;
        },
        studentName() {
            return this.$store.state.user.first_name + " " + this.$store.state.user.last_name;
        },
        reportDate() {
            return this.sco.score_recorded_at;
        },
        group() {
            return this.careOf ? this.careOf : " ";
        },
        lessonLocation() {
            return this.sco.lesson_location;
        },
        cacheBuster() {
            return Date.now();
        }
    },
    methods: {
        openReport() {
            this.preparingReport = true;
            this.$nextTick(() => {
                this.showReport = true;
            });
        },
        closeReport() {
            this.showReport = false;
            this.$nextTick(() => {
                this.preparingReport = false;
            });
        }
    }
};
</script>
